import { call, put, takeEvery } from 'redux-saga/effects'

import * as Api from '../api/tokens-api';

// import { createAlert } from '../services/alert-service';

function* fetchTokens(action) {
    try {
        const tokens = yield call(Api.fetchTokens);
        yield put({
            type: 'TOKENS_FETCH_SUCCEEDED',
            payload: { tokens }
        });
    } catch (e) {
        yield put({
            type: 'TOKENS_FETCH_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* createToken(action) {
    try {
        const token = yield call(Api.createToken, action.payload.url, action.payload.role, action.payload.project);

        yield put({
            type: 'TOKEN_CREATE_SUCCEEDED',
            payload: {
                token: {
                    url: action.payload.url,
                    role: action.payload.role,
                    project: action.payload.project,
                    ...token
                }
            }
        });

        action.onComplete && action.onComplete(token);
    } catch (e) {
        yield put({
            type: 'TOKEN_CREATE_FAILED',
            payload: {
                message: e.message || e,
                url: action.payload.url,
                role: action.payload.role,
                project: action.payload.project
            }
        });

        action.onError && action.onError(e);
    }
}

function* removeToken(action) {
    try {
        yield call(Api.removeToken, action.payload.tokenId);
        yield put({
            type: 'TOKEN_REMOVE_SUCCEEDED',
            payload: {
                tokenId: action.payload.tokenId
            }
        });

        action.onComplete && action.onComplete();
    } catch (e) {
        yield put({
            type: 'TOKEN_REMOVE_FAILED',
            payload: {
                tokenId: action.payload.tokenId,
                message: e.message || e
            }
        });

        action.onError && action.onError(e);
    }
}

function* watchGetTokens() {
    yield takeEvery('TOKENS_FETCH_REQUESTED', fetchTokens);
}

function* watchCreateToken() {
    yield takeEvery('TOKEN_CREATE_REQUESTED', createToken);
}

function* watchRemoveToken() {
    yield takeEvery('TOKEN_REMOVE_REQUESTED', removeToken);
}

export default [watchGetTokens, watchCreateToken, watchRemoveToken];
